import {use} from 'react'
import {ToggleContext} from './toggle-context'
import {type ReturnType} from './types/return-type'

export function useToggle(): ReturnType {
    const toggle = use(ToggleContext)

    if (!toggle) {
        throw new Error('useToggle must be used within a ToggleContext')
    }

    return toggle
}
